<template>
  <el-upload
      class="file-uploader"
      :action="action"
      :multiple="multiple"
      :limit="limit"
      :data="data"
      :accept="accept"
      :show-file-list="showFileList"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-change="handleChange"
      :before-upload="onBeforeUpload"
      :on-remove="handleRemove"
      :file-list="internalFileList"
      :auto-upload="autoUpload"
      list-type="text"
  >
    <el-button size="small" type="primary">{{ buttonText }}</el-button>

    <!-- 自定义文件项 -->
    <template #file="{ file }">
      <div style="display: flex; align-items: center;">
        <!-- 改为点击触发下载，而不是直接跳转 href -->
        <el-link
            style="margin-right: 10px;"
            v-if="file.url"
            @click.prevent="downloadFile(file.url, file.name)"
        >
          {{ file.name }}
        </el-link>
        <span v-else style="margin-right: 10px;">{{ file.name }}</span>
        <el-button
            size="mini"
            type="text"
            @click="removeFile(file)"
        >
          删除
        </el-button>
      </div>
    </template>

    <div slot="tip" class="el-upload__tip" v-if="tip">{{ tip }}</div>
  </el-upload>
</template>

<script>
import { API_BASE_URL } from "@/config";

export default {
  name: 'FileUploader',

  props: {
    action: { type: String, default: API_BASE_URL + 'Airdrop/uploadPic' },

    multiple: { type: Boolean, default: false },
    limit: { type: Number, default: 0 },
    data: {
      type: Object, default: () => {
        let shangchuanData = {}
        let xinxi = sessionStorage.getItem('admintoken') ? sessionStorage.getItem('admintoken') : ''
        shangchuanData.token = xinxi ? xinxi : ''
        return shangchuanData
      }
    },
    accept: { type: String, default: '' },
    showFileList: { type: Boolean, default: true },
    fileList: { type: Array, default: () => [] },
    autoUpload: { type: Boolean, default: true },
    buttonText: { type: String, default: '点击上传' },
    tip: { type: String, default: '' },
    beforeUpload: { type: Function, default: () => true },
  },
  data() {
    return {
      internalFileList: []
    };
  },
  watch: {
    fileList: {
      immediate: true,
      handler(newVal) {
        this.internalFileList = [...newVal];
      }
    }
  },
  methods: {
    onBeforeUpload(file) {
      // 上传前把最新 token 写进 data（原地改），避免空 token →「请先登录」
      const token = sessionStorage.getItem('admintoken') || ''
      if (this.data && typeof this.data === 'object') {
        this.$set(this.data, 'token', token)
      }
      if (typeof this.beforeUpload === 'function') {
        return this.beforeUpload(file)
      }
      return true
    },
    handleSuccess(response, file, fileList) {
      // 登录超时 / 无效令牌等（admproj 接口）
      if (response && (response.status == -999 || response.status == -998 || response.status == -997)) {
        this.$message.error(response.info || '登录已失效，请重新登录')
        this.$emit('error', new Error(response.info || '登录已失效'), file, fileList)
        return
      }
      // 兼容：admproj {status:1,img} 与网关 {code:1,data.url}
      const ok = response && (response.status == 1 || response.code == 1)
      if (!ok) {
        const msg = (response && (response.info || response.msg)) ? (response.info || response.msg) : '文件上传失败'
        this.$message.error(msg)
        this.$emit('error', new Error(msg), file, fileList)
        return
      }
      file.url = response.img
        || (response.data && response.data.url)
        || response.url
        || ''
      this.internalFileList = [...fileList]
      this.$emit('success', file)
    },
    handleError(err, file, fileList) {
      this.$emit('error', err, file, fileList);
    },
    handleChange(file, fileList) {
      this.internalFileList = [...fileList];
      this.$emit('change', file, fileList);
    },
    handleRemove(file, fileList) {
      this.internalFileList = [...fileList];
      this.$emit('remove', file, fileList);
    },
    removeFile(file) {
      const index = this.internalFileList.findIndex(f => f.uid === file.uid);
      if (index !== -1) {
        this.internalFileList.splice(index, 1);
        this.$emit('remove', file, this.internalFileList);
      }
    },

    // ========== 新增：安全下载方法（解决OSS签名失效问题） ==========
    downloadFile(fileUrl, fileName) {
      if (!fileUrl) return;
      
      // 1. 自动修复 &amp; 为 & —— 最关键
      let url = fileUrl.replace(/&amp;/g, '&');
      
      // 2. 创建a标签下载，保证文件名正确、签名有效
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 自动使用正确文件名
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
};
</script>

<style scoped>
.file-uploader {
  margin: 10px 0;
}
</style>